export const mapping: Record<string, string> = {
  'transactionInfo.externalTransactionId': 'd=>d.ExternalTransactionID',
  'transactionInfo.date': 'd=>d.Date',
  id: 'd=>d.ID',
}

const mapSortParam = (key: string) => mapping[key]

export default mapSortParam
